export const recentStub = {
    "typeMatches": [
        {
            "matchType": "International",
            "seriesMatches": [
                {
                    "seriesAdWrapper": {
                        "seriesId": 7476,
                        "seriesName": "ICC Mens T20 World Cup 2024",
                        "matches": [
                            {
                                "matchInfo": {
                                    "matchId": 87731,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "34th Match, Group B",
                                    "matchFormat": "T20",
                                    "startDate": "1718470800000",
                                    "endDate": "1718483400000",
                                    "state": "Complete",
                                    "status": "England won by 41 runs (DLS method)",
                                    "team1": {
                                        "teamId": 9,
                                        "teamName": "England",
                                        "teamSName": "ENG",
                                        "imageId": 172123
                                    },
                                    "team2": {
                                        "teamId": 161,
                                        "teamName": "Namibia",
                                        "teamSName": "NAM",
                                        "imageId": 172229
                                    },
                                    "venueInfo": {
                                        "id": 109,
                                        "ground": "Sir Vivian Richards Stadium",
                                        "city": "North Sound, Antigua",
                                        "timezone": "-04:00",
                                        "latitude": "17.103332",
                                        "longitude": "-61.784959"
                                    },
                                    "currBatTeamId": 9,
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "ENG Won",
                                    "isFantasyEnabled": true
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 122,
                                            "wickets": 5,
                                            "overs": 9.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 84,
                                            "wickets": 3,
                                            "overs": 9.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87724,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "33rd Match, Group A",
                                    "matchFormat": "T20",
                                    "startDate": "1718461800000",
                                    "endDate": "1718474400000",
                                    "state": "Complete",
                                    "status": "Match abandoned due to wet outfield (no toss)",
                                    "team1": {
                                        "teamId": 2,
                                        "teamName": "India",
                                        "teamSName": "IND",
                                        "imageId": 172115
                                    },
                                    "team2": {
                                        "teamId": 26,
                                        "teamName": "Canada",
                                        "teamSName": "CAN",
                                        "imageId": 172140
                                    },
                                    "venueInfo": {
                                        "id": 270,
                                        "ground": "Central Broward Regional Park Stadium Turf Ground",
                                        "city": "Lauderhill, Florida",
                                        "timezone": "-04:00",
                                        "latitude": "26.149670",
                                        "longitude": "-80.212196"
                                    },
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Abandon",
                                    "isFantasyEnabled": true
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87717,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "32nd Match, Group C",
                                    "matchFormat": "T20",
                                    "startDate": "1718411400000",
                                    "endDate": "1718424000000",
                                    "state": "Complete",
                                    "status": "New Zealand won by 9 wkts",
                                    "team1": {
                                        "teamId": 44,
                                        "teamName": "Uganda",
                                        "teamSName": "UGA",
                                        "imageId": 495000
                                    },
                                    "team2": {
                                        "teamId": 13,
                                        "teamName": "New Zealand",
                                        "teamSName": "NZ",
                                        "imageId": 172128
                                    },
                                    "venueInfo": {
                                        "id": 500,
                                        "ground": "Brian Lara Stadium",
                                        "city": "Tarouba, Trinidad",
                                        "timezone": "-04:00",
                                        "latitude": "10.295034",
                                        "longitude": "-61.445609"
                                    },
                                    "currBatTeamId": 13,
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "NZ Won",
                                    "isFantasyEnabled": true
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 40,
                                            "wickets": 10,
                                            "overs": 18.4
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 41,
                                            "wickets": 1,
                                            "overs": 5.2
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87710,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "31st Match, Group D",
                                    "matchFormat": "T20",
                                    "startDate": "1718407800000",
                                    "endDate": "1718420400000",
                                    "state": "Complete",
                                    "status": "South Africa won by 1 run",
                                    "team1": {
                                        "teamId": 11,
                                        "teamName": "South Africa",
                                        "teamSName": "RSA",
                                        "imageId": 172126
                                    },
                                    "team2": {
                                        "teamId": 72,
                                        "teamName": "Nepal",
                                        "teamSName": "NEP",
                                        "imageId": 172169
                                    },
                                    "venueInfo": {
                                        "id": 58,
                                        "ground": "Arnos Vale Ground",
                                        "city": "Kingstown, St Vincent",
                                        "timezone": "-04:00",
                                        "latitude": "13.141873",
                                        "longitude": "-61.211811"
                                    },
                                    "currBatTeamId": 11,
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "RSA Won",
                                    "isFantasyEnabled": true
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 115,
                                            "wickets": 7,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 114,
                                            "wickets": 7,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87703,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "30th Match, Group A",
                                    "matchFormat": "T20",
                                    "startDate": "1718375400000",
                                    "endDate": "1718388000000",
                                    "state": "Complete",
                                    "status": "Match abandoned due to rain",
                                    "team1": {
                                        "teamId": 15,
                                        "teamName": "United States",
                                        "teamSName": "USA",
                                        "imageId": 172130
                                    },
                                    "team2": {
                                        "teamId": 27,
                                        "teamName": "Ireland",
                                        "teamSName": "IRE",
                                        "imageId": 495001
                                    },
                                    "venueInfo": {
                                        "id": 270,
                                        "ground": "Central Broward Regional Park Stadium Turf Ground",
                                        "city": "Lauderhill, Florida",
                                        "timezone": "-04:00",
                                        "latitude": "26.149670",
                                        "longitude": "-80.212196"
                                    },
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Abandon",
                                    "isFantasyEnabled": true
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87696,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "29th Match, Group C",
                                    "matchFormat": "T20",
                                    "startDate": "1718325000000",
                                    "endDate": "1718337600000",
                                    "state": "Complete",
                                    "status": "Afghanistan won by 7 wkts",
                                    "team1": {
                                        "teamId": 287,
                                        "teamName": "Papua New Guinea",
                                        "teamSName": "PNG",
                                        "imageId": 172336
                                    },
                                    "team2": {
                                        "teamId": 96,
                                        "teamName": "Afghanistan",
                                        "teamSName": "AFG",
                                        "imageId": 172188
                                    },
                                    "venueInfo": {
                                        "id": 500,
                                        "ground": "Brian Lara Stadium",
                                        "city": "Tarouba, Trinidad",
                                        "timezone": "-04:00",
                                        "latitude": "10.295034",
                                        "longitude": "-61.445609"
                                    },
                                    "currBatTeamId": 96,
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "AFG Won",
                                    "isFantasyEnabled": true
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 95,
                                            "wickets": 10,
                                            "overs": 19.5
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 101,
                                            "wickets": 3,
                                            "overs": 15.1
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87682,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "28th Match, Group B",
                                    "matchFormat": "T20",
                                    "startDate": "1718305200000",
                                    "endDate": "1718317800000",
                                    "state": "Complete",
                                    "status": "England won by 8 wkts",
                                    "team1": {
                                        "teamId": 304,
                                        "teamName": "Oman",
                                        "teamSName": "OMAN",
                                        "imageId": 172353
                                    },
                                    "team2": {
                                        "teamId": 9,
                                        "teamName": "England",
                                        "teamSName": "ENG",
                                        "imageId": 172123
                                    },
                                    "venueInfo": {
                                        "id": 109,
                                        "ground": "Sir Vivian Richards Stadium",
                                        "city": "North Sound, Antigua",
                                        "timezone": "-04:00",
                                        "latitude": "17.103332",
                                        "longitude": "-61.784959"
                                    },
                                    "currBatTeamId": 9,
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "ENG Won",
                                    "isFantasyEnabled": true
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 47,
                                            "wickets": 10,
                                            "overs": 13.2
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 50,
                                            "wickets": 2,
                                            "overs": 3.1
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87689,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "27th Match, Group D",
                                    "matchFormat": "T20",
                                    "startDate": "1718289000000",
                                    "endDate": "1718301600000",
                                    "state": "Complete",
                                    "status": "Bangladesh won by 25 runs",
                                    "team1": {
                                        "teamId": 6,
                                        "teamName": "Bangladesh",
                                        "teamSName": "BAN",
                                        "imageId": 172120
                                    },
                                    "team2": {
                                        "teamId": 24,
                                        "teamName": "Netherlands",
                                        "teamSName": "NED",
                                        "imageId": 172138
                                    },
                                    "venueInfo": {
                                        "id": 58,
                                        "ground": "Arnos Vale Ground",
                                        "city": "Kingstown, St Vincent",
                                        "timezone": "-04:00",
                                        "latitude": "13.141873",
                                        "longitude": "-61.211811"
                                    },
                                    "currBatTeamId": 6,
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "BAN Won",
                                    "isFantasyEnabled": true
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 159,
                                            "wickets": 5,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 134,
                                            "wickets": 8,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87675,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "26th Match, Group C",
                                    "matchFormat": "T20",
                                    "startDate": "1718238600000",
                                    "endDate": "1718251200000",
                                    "state": "Complete",
                                    "status": "West Indies won by 13 runs",
                                    "team1": {
                                        "teamId": 10,
                                        "teamName": "West Indies",
                                        "teamSName": "WI",
                                        "imageId": 172124
                                    },
                                    "team2": {
                                        "teamId": 13,
                                        "teamName": "New Zealand",
                                        "teamSName": "NZ",
                                        "imageId": 172128
                                    },
                                    "venueInfo": {
                                        "id": 500,
                                        "ground": "Brian Lara Stadium",
                                        "city": "Tarouba, Trinidad",
                                        "timezone": "-04:00",
                                        "latitude": "10.295034",
                                        "longitude": "-61.445609"
                                    },
                                    "currBatTeamId": 10,
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "WI Won",
                                    "isFantasyEnabled": true
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 149,
                                            "wickets": 9,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 136,
                                            "wickets": 9,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87668,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "25th Match, Group A",
                                    "matchFormat": "T20",
                                    "startDate": "1718202600000",
                                    "endDate": "1718215200000",
                                    "state": "Complete",
                                    "status": "India won by 7 wkts",
                                    "team1": {
                                        "teamId": 15,
                                        "teamName": "United States",
                                        "teamSName": "USA",
                                        "imageId": 172130
                                    },
                                    "team2": {
                                        "teamId": 2,
                                        "teamName": "India",
                                        "teamSName": "IND",
                                        "imageId": 172115
                                    },
                                    "venueInfo": {
                                        "id": 1811,
                                        "ground": "Nassau County International Cricket Stadium",
                                        "city": "New York",
                                        "timezone": "-04:00",
                                        "latitude": "40.712772",
                                        "longitude": "-74.006058"
                                    },
                                    "currBatTeamId": 2,
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "IND Won",
                                    "isFantasyEnabled": true
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 110,
                                            "wickets": 8,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 111,
                                            "wickets": 3,
                                            "overs": 18.2
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87661,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "24th Match, Group B",
                                    "matchFormat": "T20",
                                    "startDate": "1718152200000",
                                    "endDate": "1718164800000",
                                    "state": "Complete",
                                    "status": "Australia won by 9 wkts",
                                    "team1": {
                                        "teamId": 161,
                                        "teamName": "Namibia",
                                        "teamSName": "NAM",
                                        "imageId": 172229
                                    },
                                    "team2": {
                                        "teamId": 4,
                                        "teamName": "Australia",
                                        "teamSName": "AUS",
                                        "imageId": 172117
                                    },
                                    "venueInfo": {
                                        "id": 109,
                                        "ground": "Sir Vivian Richards Stadium",
                                        "city": "North Sound, Antigua",
                                        "timezone": "-04:00",
                                        "latitude": "17.103332",
                                        "longitude": "-61.784959"
                                    },
                                    "currBatTeamId": 4,
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "AUS Won",
                                    "isFantasyEnabled": true
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 72,
                                            "wickets": 10,
                                            "overs": 16.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 74,
                                            "wickets": 1,
                                            "overs": 5.4
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87654,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "23rd Match, Group D",
                                    "matchFormat": "T20",
                                    "startDate": "1718148600000",
                                    "endDate": "1718161200000",
                                    "state": "Complete",
                                    "status": "Match abandoned due to rain",
                                    "team1": {
                                        "teamId": 5,
                                        "teamName": "Sri Lanka",
                                        "teamSName": "SL",
                                        "imageId": 172119
                                    },
                                    "team2": {
                                        "teamId": 72,
                                        "teamName": "Nepal",
                                        "teamSName": "NEP",
                                        "imageId": 172169
                                    },
                                    "venueInfo": {
                                        "id": 270,
                                        "ground": "Central Broward Regional Park Stadium Turf Ground",
                                        "city": "Lauderhill, Florida",
                                        "timezone": "-04:00",
                                        "latitude": "26.149670",
                                        "longitude": "-80.212196"
                                    },
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Abandon",
                                    "isFantasyEnabled": true
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87647,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "22nd Match, Group A",
                                    "matchFormat": "T20",
                                    "startDate": "1718116200000",
                                    "endDate": "1718128800000",
                                    "state": "Complete",
                                    "status": "Pakistan won by 7 wkts",
                                    "team1": {
                                        "teamId": 26,
                                        "teamName": "Canada",
                                        "teamSName": "CAN",
                                        "imageId": 172140
                                    },
                                    "team2": {
                                        "teamId": 3,
                                        "teamName": "Pakistan",
                                        "teamSName": "PAK",
                                        "imageId": 172116
                                    },
                                    "venueInfo": {
                                        "id": 1811,
                                        "ground": "Nassau County International Cricket Stadium",
                                        "city": "New York",
                                        "timezone": "-04:00",
                                        "latitude": "40.712772",
                                        "longitude": "-74.006058"
                                    },
                                    "currBatTeamId": 3,
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "PAK Won",
                                    "isFantasyEnabled": true
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 106,
                                            "wickets": 7,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 107,
                                            "wickets": 3,
                                            "overs": 17.3
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87640,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "21st Match, Group D",
                                    "matchFormat": "T20",
                                    "startDate": "1718029800000",
                                    "endDate": "1718042400000",
                                    "state": "Complete",
                                    "status": "South Africa won by 4 runs",
                                    "team1": {
                                        "teamId": 11,
                                        "teamName": "South Africa",
                                        "teamSName": "RSA",
                                        "imageId": 172126
                                    },
                                    "team2": {
                                        "teamId": 6,
                                        "teamName": "Bangladesh",
                                        "teamSName": "BAN",
                                        "imageId": 172120
                                    },
                                    "venueInfo": {
                                        "id": 1811,
                                        "ground": "Nassau County International Cricket Stadium",
                                        "city": "New York",
                                        "timezone": "-04:00",
                                        "latitude": "40.712772",
                                        "longitude": "-74.006058"
                                    },
                                    "currBatTeamId": 11,
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "RSA Won",
                                    "isFantasyEnabled": true
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 113,
                                            "wickets": 6,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 109,
                                            "wickets": 7,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87633,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "20th Match, Group B",
                                    "matchFormat": "T20",
                                    "startDate": "1717952400000",
                                    "endDate": "1717965000000",
                                    "state": "Complete",
                                    "status": "Scotland won by 7 wkts",
                                    "team1": {
                                        "teamId": 304,
                                        "teamName": "Oman",
                                        "teamSName": "OMAN",
                                        "imageId": 172353
                                    },
                                    "team2": {
                                        "teamId": 23,
                                        "teamName": "Scotland",
                                        "teamSName": "SCO",
                                        "imageId": 172137
                                    },
                                    "venueInfo": {
                                        "id": 109,
                                        "ground": "Sir Vivian Richards Stadium",
                                        "city": "North Sound, Antigua",
                                        "timezone": "-04:00",
                                        "latitude": "17.103332",
                                        "longitude": "-61.784959"
                                    },
                                    "currBatTeamId": 23,
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "SCO Won",
                                    "isFantasyEnabled": true
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 150,
                                            "wickets": 7,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 153,
                                            "wickets": 3,
                                            "overs": 13.1
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87626,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "19th Match, Group A",
                                    "matchFormat": "T20",
                                    "startDate": "1717943400000",
                                    "endDate": "1717956000000",
                                    "state": "Complete",
                                    "status": "India won by 6 runs",
                                    "team1": {
                                        "teamId": 2,
                                        "teamName": "India",
                                        "teamSName": "IND",
                                        "imageId": 172115
                                    },
                                    "team2": {
                                        "teamId": 3,
                                        "teamName": "Pakistan",
                                        "teamSName": "PAK",
                                        "imageId": 172116
                                    },
                                    "venueInfo": {
                                        "id": 1811,
                                        "ground": "Nassau County International Cricket Stadium",
                                        "city": "New York",
                                        "timezone": "-04:00",
                                        "latitude": "40.712772",
                                        "longitude": "-74.006058"
                                    },
                                    "currBatTeamId": 2,
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "IND Won",
                                    "isFantasyEnabled": true
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 119,
                                            "wickets": 10,
                                            "overs": 18.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 113,
                                            "wickets": 7,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87619,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "18th Match, Group C",
                                    "matchFormat": "T20",
                                    "startDate": "1717893000000",
                                    "endDate": "1717905600000",
                                    "state": "Complete",
                                    "status": "West Indies won by 134 runs",
                                    "team1": {
                                        "teamId": 10,
                                        "teamName": "West Indies",
                                        "teamSName": "WI",
                                        "imageId": 172124
                                    },
                                    "team2": {
                                        "teamId": 44,
                                        "teamName": "Uganda",
                                        "teamSName": "UGA",
                                        "imageId": 495000
                                    },
                                    "venueInfo": {
                                        "id": 110,
                                        "ground": "Providence Stadium",
                                        "city": "Guyana",
                                        "timezone": "-04:00",
                                        "latitude": "41.823872",
                                        "longitude": "-71.411987"
                                    },
                                    "currBatTeamId": 10,
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "WI Won",
                                    "isFantasyEnabled": true
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 173,
                                            "wickets": 5,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 39,
                                            "wickets": 10,
                                            "overs": 11.6
                                        }
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    "adDetail": {
                        "name": "native_matches",
                        "layout": "native_large",
                        "position": 1
                    }
                },
                {
                    "seriesAdWrapper": {
                        "seriesId": 8294,
                        "seriesName": "Guernsey tour of Belgium, 2024",
                        "matches": [
                            {
                                "matchInfo": {
                                    "matchId": 96638,
                                    "seriesId": 8294,
                                    "seriesName": "Guernsey tour of Belgium, 2024",
                                    "matchDesc": "4th T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1717941600000",
                                    "endDate": "1717954200000",
                                    "state": "Complete",
                                    "status": "Guernsey won by 7 wkts",
                                    "team1": {
                                        "teamId": 541,
                                        "teamName": "Belgium",
                                        "teamSName": "BEL",
                                        "imageId": 172592
                                    },
                                    "team2": {
                                        "teamId": 533,
                                        "teamName": "Guernsey",
                                        "teamSName": "GGY",
                                        "imageId": 172584
                                    },
                                    "venueInfo": {
                                        "id": 559,
                                        "ground": "Royal Brussels Cricket Ground",
                                        "city": "Brussels",
                                        "timezone": "+02:00",
                                        "latitude": "50.850346",
                                        "longitude": "4.351721"
                                    },
                                    "currBatTeamId": 533,
                                    "seriesStartDt": "1717804800000",
                                    "seriesEndDt": "1718064000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "GGY Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 125,
                                            "wickets": 9,
                                            "overs": 20.0
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 129,
                                            "wickets": 3,
                                            "overs": 15.3
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96631,
                                    "seriesId": 8294,
                                    "seriesName": "Guernsey tour of Belgium, 2024",
                                    "matchDesc": "3rd T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1717925400000",
                                    "endDate": "1717938000000",
                                    "state": "Complete",
                                    "status": "Belgium won by 6 wkts",
                                    "team1": {
                                        "teamId": 533,
                                        "teamName": "Guernsey",
                                        "teamSName": "GGY",
                                        "imageId": 172584
                                    },
                                    "team2": {
                                        "teamId": 541,
                                        "teamName": "Belgium",
                                        "teamSName": "BEL",
                                        "imageId": 172592
                                    },
                                    "venueInfo": {
                                        "id": 559,
                                        "ground": "Royal Brussels Cricket Ground",
                                        "city": "Brussels",
                                        "timezone": "+02:00",
                                        "latitude": "50.850346",
                                        "longitude": "4.351721"
                                    },
                                    "currBatTeamId": 541,
                                    "seriesStartDt": "1717804800000",
                                    "seriesEndDt": "1718064000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "BEL Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 192,
                                            "wickets": 6,
                                            "overs": 20.0
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 195,
                                            "wickets": 4,
                                            "overs": 19.2
                                        }
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    "seriesAdWrapper": {
                        "seriesId": 8256,
                        "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                        "matches": [
                            {
                                "matchInfo": {
                                    "matchId": 96424,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "19th Match, Group A",
                                    "matchFormat": "T20",
                                    "startDate": "1718457300000",
                                    "endDate": "1718469900000",
                                    "state": "Complete",
                                    "status": "France won by 40 runs",
                                    "team1": {
                                        "teamId": 539,
                                        "teamName": "France",
                                        "teamSName": "FRA",
                                        "imageId": 172590
                                    },
                                    "team2": {
                                        "teamId": 897,
                                        "teamName": "Turkey",
                                        "teamSName": "TKY",
                                        "imageId": 247208
                                    },
                                    "venueInfo": {
                                        "id": 1475,
                                        "ground": "Roma Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "currBatTeamId": 539,
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "FRA Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 167,
                                            "wickets": 6,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 127,
                                            "wickets": 10,
                                            "overs": 19.3
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96433,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "20th Match, Group B",
                                    "matchFormat": "T20",
                                    "startDate": "1718457300000",
                                    "endDate": "1718469900000",
                                    "state": "Complete",
                                    "status": "Romania won by 24 runs",
                                    "team1": {
                                        "teamId": 1041,
                                        "teamName": "Romania",
                                        "teamSName": "ROM",
                                        "imageId": 247204
                                    },
                                    "team2": {
                                        "teamId": 554,
                                        "teamName": "Israel",
                                        "teamSName": "ISR",
                                        "imageId": 172606
                                    },
                                    "venueInfo": {
                                        "id": 1942,
                                        "ground": "Simar Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "currBatTeamId": 1041,
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "ROM Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 149,
                                            "wickets": 7,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 125,
                                            "wickets": 7,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96411,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "17th Match, Group A",
                                    "matchFormat": "T20",
                                    "startDate": "1718439300000",
                                    "endDate": "1718451900000",
                                    "state": "Complete",
                                    "status": "Isle of Man won by 63 runs",
                                    "team1": {
                                        "teamId": 557,
                                        "teamName": "Isle of Man",
                                        "teamSName": "IOM",
                                        "imageId": 172609
                                    },
                                    "team2": {
                                        "teamId": 537,
                                        "teamName": "Luxembourg",
                                        "teamSName": "LUX",
                                        "imageId": 172588
                                    },
                                    "venueInfo": {
                                        "id": 1475,
                                        "ground": "Roma Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "currBatTeamId": 557,
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "IOM Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 154,
                                            "wickets": 8,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 91,
                                            "wickets": 10,
                                            "overs": 14.3
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96420,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "18th Match, Group B",
                                    "matchFormat": "T20",
                                    "startDate": "1718439300000",
                                    "endDate": "1718451900000",
                                    "state": "Complete",
                                    "status": "Austria won by 14 runs",
                                    "team1": {
                                        "teamId": 532,
                                        "teamName": "Austria",
                                        "teamSName": "AUT",
                                        "imageId": 172583
                                    },
                                    "team2": {
                                        "teamId": 550,
                                        "teamName": "Hungary",
                                        "teamSName": "HUN",
                                        "imageId": 172602
                                    },
                                    "venueInfo": {
                                        "id": 1942,
                                        "ground": "Simar Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "currBatTeamId": 532,
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "AUT Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 187,
                                            "wickets": 7,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 173,
                                            "wickets": 9,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96402,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "16th Match, Group A",
                                    "matchFormat": "T20",
                                    "startDate": "1718284500000",
                                    "endDate": "1718297100000",
                                    "state": "Complete",
                                    "status": "Italy won by 9 wkts",
                                    "team1": {
                                        "teamId": 897,
                                        "teamName": "Turkey",
                                        "teamSName": "TKY",
                                        "imageId": 247208
                                    },
                                    "team2": {
                                        "teamId": 527,
                                        "teamName": "Italy",
                                        "teamSName": "ITA",
                                        "imageId": 172577
                                    },
                                    "venueInfo": {
                                        "id": 1942,
                                        "ground": "Simar Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "currBatTeamId": 527,
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "ITA Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 86,
                                            "wickets": 10,
                                            "overs": 19.3
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 90,
                                            "wickets": 1,
                                            "overs": 11.5
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96397,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "15th Match, Group B",
                                    "matchFormat": "T20",
                                    "startDate": "1718284500000",
                                    "endDate": "1718297100000",
                                    "state": "Complete",
                                    "status": "Israel won by 2 wkts",
                                    "team1": {
                                        "teamId": 596,
                                        "teamName": "Portugal",
                                        "teamSName": "PORT",
                                        "imageId": 248442
                                    },
                                    "team2": {
                                        "teamId": 554,
                                        "teamName": "Israel",
                                        "teamSName": "ISR",
                                        "imageId": 172606
                                    },
                                    "venueInfo": {
                                        "id": 1475,
                                        "ground": "Roma Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "currBatTeamId": 554,
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "ISR Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 118,
                                            "wickets": 6,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 119,
                                            "wickets": 8,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96384,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "13th Match, Group B",
                                    "matchFormat": "T20",
                                    "startDate": "1718266500000",
                                    "endDate": "1718279100000",
                                    "state": "Complete",
                                    "status": "Romania won by 8 wkts",
                                    "team1": {
                                        "teamId": 550,
                                        "teamName": "Hungary",
                                        "teamSName": "HUN",
                                        "imageId": 172602
                                    },
                                    "team2": {
                                        "teamId": 1041,
                                        "teamName": "Romania",
                                        "teamSName": "ROM",
                                        "imageId": 247204
                                    },
                                    "venueInfo": {
                                        "id": 1475,
                                        "ground": "Roma Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "currBatTeamId": 1041,
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "ROM Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 110,
                                            "wickets": 10,
                                            "overs": 18.2
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 111,
                                            "wickets": 2,
                                            "overs": 12.1
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96393,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "14th Match, Group A",
                                    "matchFormat": "T20",
                                    "startDate": "1718266500000",
                                    "endDate": "1718279100000",
                                    "state": "Complete",
                                    "status": "France won by 13 runs",
                                    "team1": {
                                        "teamId": 539,
                                        "teamName": "France",
                                        "teamSName": "FRA",
                                        "imageId": 172590
                                    },
                                    "team2": {
                                        "teamId": 537,
                                        "teamName": "Luxembourg",
                                        "teamSName": "LUX",
                                        "imageId": 172588
                                    },
                                    "venueInfo": {
                                        "id": 1942,
                                        "ground": "Simar Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "currBatTeamId": 539,
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "FRA Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 145,
                                            "wickets": 6,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 132,
                                            "wickets": 6,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96375,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "11th Match, Group A",
                                    "matchFormat": "T20",
                                    "startDate": "1718198100000",
                                    "endDate": "1718210700000",
                                    "state": "Complete",
                                    "status": "Luxembourg won by 73 runs",
                                    "team1": {
                                        "teamId": 537,
                                        "teamName": "Luxembourg",
                                        "teamSName": "LUX",
                                        "imageId": 172588
                                    },
                                    "team2": {
                                        "teamId": 897,
                                        "teamName": "Turkey",
                                        "teamSName": "TKY",
                                        "imageId": 247208
                                    },
                                    "venueInfo": {
                                        "id": 1475,
                                        "ground": "Roma Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "currBatTeamId": 537,
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "LUX Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 147,
                                            "wickets": 9,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 74,
                                            "wickets": 10,
                                            "overs": 15.5
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96379,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "12th Match, Group B",
                                    "matchFormat": "T20",
                                    "startDate": "1718198100000",
                                    "endDate": "1718210700000",
                                    "state": "Complete",
                                    "status": "Hungary won by 1 wkt",
                                    "team1": {
                                        "teamId": 554,
                                        "teamName": "Israel",
                                        "teamSName": "ISR",
                                        "imageId": 172606
                                    },
                                    "team2": {
                                        "teamId": 550,
                                        "teamName": "Hungary",
                                        "teamSName": "HUN",
                                        "imageId": 172602
                                    },
                                    "venueInfo": {
                                        "id": 1942,
                                        "ground": "Simar Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "currBatTeamId": 550,
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "HUN Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 122,
                                            "wickets": 8,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 123,
                                            "wickets": 9,
                                            "overs": 19.2
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96366,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "9th Match, Group A",
                                    "matchFormat": "T20",
                                    "startDate": "1718180100000",
                                    "endDate": "1718192700000",
                                    "state": "Complete",
                                    "status": "Italy won by 7 wkts",
                                    "team1": {
                                        "teamId": 557,
                                        "teamName": "Isle of Man",
                                        "teamSName": "IOM",
                                        "imageId": 172609
                                    },
                                    "team2": {
                                        "teamId": 527,
                                        "teamName": "Italy",
                                        "teamSName": "ITA",
                                        "imageId": 172577
                                    },
                                    "venueInfo": {
                                        "id": 1475,
                                        "ground": "Roma Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "currBatTeamId": 527,
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "ITA Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 85,
                                            "wickets": 10,
                                            "overs": 17.5
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 87,
                                            "wickets": 3,
                                            "overs": 14.3
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96370,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "10th Match, Group B",
                                    "matchFormat": "T20",
                                    "startDate": "1718180100000",
                                    "endDate": "1718192700000",
                                    "state": "Complete",
                                    "status": "Austria won by 7 wkts",
                                    "team1": {
                                        "teamId": 596,
                                        "teamName": "Portugal",
                                        "teamSName": "PORT",
                                        "imageId": 248442
                                    },
                                    "team2": {
                                        "teamId": 532,
                                        "teamName": "Austria",
                                        "teamSName": "AUT",
                                        "imageId": 172583
                                    },
                                    "venueInfo": {
                                        "id": 1942,
                                        "ground": "Simar Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "currBatTeamId": 532,
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "AUT Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 125,
                                            "wickets": 9,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 128,
                                            "wickets": 3,
                                            "overs": 14.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96361,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "8th Match, Group A",
                                    "matchFormat": "T20",
                                    "startDate": "1718025300000",
                                    "endDate": "1718037900000",
                                    "state": "Complete",
                                    "status": "Italy won by 5 wkts",
                                    "team1": {
                                        "teamId": 539,
                                        "teamName": "France",
                                        "teamSName": "FRA",
                                        "imageId": 172590
                                    },
                                    "team2": {
                                        "teamId": 527,
                                        "teamName": "Italy",
                                        "teamSName": "ITA",
                                        "imageId": 172577
                                    },
                                    "venueInfo": {
                                        "id": 1942,
                                        "ground": "Simar Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "currBatTeamId": 527,
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "ITA Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 116,
                                            "wickets": 10,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 118,
                                            "wickets": 5,
                                            "overs": 18.2
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96352,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "7th Match, Group B",
                                    "matchFormat": "T20",
                                    "startDate": "1718025300000",
                                    "endDate": "1718037900000",
                                    "state": "Complete",
                                    "status": "Romania won by 6 wkts",
                                    "team1": {
                                        "teamId": 596,
                                        "teamName": "Portugal",
                                        "teamSName": "PORT",
                                        "imageId": 248442
                                    },
                                    "team2": {
                                        "teamId": 1041,
                                        "teamName": "Romania",
                                        "teamSName": "ROM",
                                        "imageId": 247204
                                    },
                                    "venueInfo": {
                                        "id": 1475,
                                        "ground": "Roma Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "currBatTeamId": 1041,
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "ROM Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 142,
                                            "wickets": 10,
                                            "overs": 19.5
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 146,
                                            "wickets": 4,
                                            "overs": 18.3
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96334,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "5th Match, Group B",
                                    "matchFormat": "T20",
                                    "startDate": "1718007300000",
                                    "endDate": "1718019900000",
                                    "state": "Complete",
                                    "status": "Austria won by 7 wkts",
                                    "team1": {
                                        "teamId": 554,
                                        "teamName": "Israel",
                                        "teamSName": "ISR",
                                        "imageId": 172606
                                    },
                                    "team2": {
                                        "teamId": 532,
                                        "teamName": "Austria",
                                        "teamSName": "AUT",
                                        "imageId": 172583
                                    },
                                    "venueInfo": {
                                        "id": 1475,
                                        "ground": "Roma Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "currBatTeamId": 532,
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "AUT Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 107,
                                            "wickets": 9,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 110,
                                            "wickets": 3,
                                            "overs": 13.1
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96343,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "6th Match, Group A",
                                    "matchFormat": "T20",
                                    "startDate": "1718007300000",
                                    "endDate": "1718019900000",
                                    "state": "Complete",
                                    "status": "Isle of Man won by 81 runs",
                                    "team1": {
                                        "teamId": 557,
                                        "teamName": "Isle of Man",
                                        "teamSName": "IOM",
                                        "imageId": 172609
                                    },
                                    "team2": {
                                        "teamId": 897,
                                        "teamName": "Turkey",
                                        "teamSName": "TKY",
                                        "imageId": 247208
                                    },
                                    "venueInfo": {
                                        "id": 1942,
                                        "ground": "Simar Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "currBatTeamId": 557,
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "IOM Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 182,
                                            "wickets": 7,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 101,
                                            "wickets": 9,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96321,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "3rd Match, Group A",
                                    "matchFormat": "T20",
                                    "startDate": "1717938900000",
                                    "endDate": "1717951500000",
                                    "state": "Complete",
                                    "status": "France won by 16 runs",
                                    "team1": {
                                        "teamId": 539,
                                        "teamName": "France",
                                        "teamSName": "FRA",
                                        "imageId": 172590
                                    },
                                    "team2": {
                                        "teamId": 557,
                                        "teamName": "Isle of Man",
                                        "teamSName": "IOM",
                                        "imageId": 172609
                                    },
                                    "venueInfo": {
                                        "id": 1475,
                                        "ground": "Roma Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "currBatTeamId": 539,
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "FRA Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 149,
                                            "wickets": 8,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 133,
                                            "wickets": 6,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96330,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "4th Match, Group B",
                                    "matchFormat": "T20",
                                    "startDate": "1717938900000",
                                    "endDate": "1717951500000",
                                    "state": "Complete",
                                    "status": "Romania won by 3 wkts",
                                    "team1": {
                                        "teamId": 532,
                                        "teamName": "Austria",
                                        "teamSName": "AUT",
                                        "imageId": 172583
                                    },
                                    "team2": {
                                        "teamId": 1041,
                                        "teamName": "Romania",
                                        "teamSName": "ROM",
                                        "imageId": 247204
                                    },
                                    "venueInfo": {
                                        "id": 1942,
                                        "ground": "Simar Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "currBatTeamId": 1041,
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "ROM Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 169,
                                            "wickets": 10,
                                            "overs": 19.4
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 170,
                                            "wickets": 7,
                                            "overs": 19.2
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96312,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "2nd Match, Group B",
                                    "matchFormat": "T20",
                                    "startDate": "1717920900000",
                                    "endDate": "1717933500000",
                                    "state": "Complete",
                                    "status": "Portugal won by 15 runs",
                                    "team1": {
                                        "teamId": 596,
                                        "teamName": "Portugal",
                                        "teamSName": "PORT",
                                        "imageId": 248442
                                    },
                                    "team2": {
                                        "teamId": 550,
                                        "teamName": "Hungary",
                                        "teamSName": "HUN",
                                        "imageId": 172602
                                    },
                                    "venueInfo": {
                                        "id": 1942,
                                        "ground": "Simar Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "currBatTeamId": 596,
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "PORT Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 147,
                                            "wickets": 9,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 132,
                                            "wickets": 5,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96303,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "1st Match, Group A",
                                    "matchFormat": "T20",
                                    "startDate": "1717920900000",
                                    "endDate": "1717933500000",
                                    "state": "Complete",
                                    "status": "Italy won by 77 runs",
                                    "team1": {
                                        "teamId": 527,
                                        "teamName": "Italy",
                                        "teamSName": "ITA",
                                        "imageId": 172577
                                    },
                                    "team2": {
                                        "teamId": 537,
                                        "teamName": "Luxembourg",
                                        "teamSName": "LUX",
                                        "imageId": 172588
                                    },
                                    "venueInfo": {
                                        "id": 1475,
                                        "ground": "Roma Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "currBatTeamId": 527,
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "ITA Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 166,
                                            "wickets": 7,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 89,
                                            "wickets": 9,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            }
                        ]
                    }
                }
            ]
        },
        {
            "matchType": "League",
            "seriesMatches": [
                {
                    "seriesAdWrapper": {
                        "seriesId": 7336,
                        "seriesName": "T20 Blast 2024",
                        "matches": [
                            {
                                "matchInfo": {
                                    "matchId": 84672,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718474400000",
                                    "endDate": "1718487000000",
                                    "state": "Complete",
                                    "status": "Surrey won by 54 runs",
                                    "team1": {
                                        "teamId": 148,
                                        "teamName": "Surrey",
                                        "teamSName": "SUR",
                                        "imageId": 172215
                                    },
                                    "team2": {
                                        "teamId": 41,
                                        "teamName": "Sussex",
                                        "teamSName": "SUS",
                                        "imageId": 172148
                                    },
                                    "venueInfo": {
                                        "id": 292,
                                        "ground": "County Ground",
                                        "city": "Hove",
                                        "timezone": "+01:00",
                                        "latitude": "50.830995",
                                        "longitude": "-0.163522"
                                    },
                                    "currBatTeamId": 148,
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "SUR Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 184,
                                            "wickets": 8,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 130,
                                            "wickets": 10,
                                            "overs": 18.1
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84679,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "North Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718458200000",
                                    "endDate": "1718470800000",
                                    "state": "Complete",
                                    "status": "No result",
                                    "team1": {
                                        "teamId": 141,
                                        "teamName": "Durham",
                                        "teamSName": "DUR",
                                        "imageId": 172208
                                    },
                                    "team2": {
                                        "teamId": 139,
                                        "teamName": "Nottinghamshire",
                                        "teamSName": "NOTTS",
                                        "imageId": 172206
                                    },
                                    "venueInfo": {
                                        "id": 18,
                                        "ground": "Trent Bridge",
                                        "city": "Nottingham",
                                        "timezone": "+01:00",
                                        "latitude": "52.936884",
                                        "longitude": "-1.132230"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Complete"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 58,
                                            "overs": 4.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84658,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718388000000",
                                    "endDate": "1718400600000",
                                    "state": "Complete",
                                    "status": "Sussex won by 8 wkts",
                                    "team1": {
                                        "teamId": 152,
                                        "teamName": "Essex",
                                        "teamSName": "ESS",
                                        "imageId": 172219
                                    },
                                    "team2": {
                                        "teamId": 41,
                                        "teamName": "Sussex",
                                        "teamSName": "SUS",
                                        "imageId": 172148
                                    },
                                    "venueInfo": {
                                        "id": 118,
                                        "ground": "County Ground",
                                        "city": "Chelmsford",
                                        "timezone": "+01:00",
                                        "latitude": "51.731580",
                                        "longitude": "0.469004"
                                    },
                                    "currBatTeamId": 41,
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "SUS Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 178,
                                            "wickets": 9,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 181,
                                            "wickets": 2,
                                            "overs": 15.4
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84644,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718388000000",
                                    "endDate": "1718400600000",
                                    "state": "Complete",
                                    "status": "No result",
                                    "team1": {
                                        "teamId": 74,
                                        "teamName": "Middlesex",
                                        "teamSName": "MDX",
                                        "imageId": 172170
                                    },
                                    "team2": {
                                        "teamId": 153,
                                        "teamName": "Hampshire",
                                        "teamSName": "HAM",
                                        "imageId": 172220
                                    },
                                    "venueInfo": {
                                        "id": 21,
                                        "ground": "The Rose Bowl",
                                        "city": "Southampton",
                                        "timezone": "+01:00",
                                        "latitude": "50.924131",
                                        "longitude": "-1.322163"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "No Result"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 113,
                                            "wickets": 8,
                                            "overs": 16.5
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84651,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "North Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718388000000",
                                    "endDate": "1718400600000",
                                    "state": "Complete",
                                    "status": "Derbyshire won by 24 runs (DLS method)   - Revised due to rain",
                                    "team1": {
                                        "teamId": 142,
                                        "teamName": "Northamptonshire",
                                        "teamSName": "NHNTS",
                                        "imageId": 172209
                                    },
                                    "team2": {
                                        "teamId": 144,
                                        "teamName": "Derbyshire",
                                        "teamSName": "DERBY",
                                        "imageId": 172211
                                    },
                                    "venueInfo": {
                                        "id": 226,
                                        "ground": "County Ground",
                                        "city": "Derby",
                                        "timezone": "+01:00",
                                        "latitude": "52.927517",
                                        "longitude": "-1.461188"
                                    },
                                    "currBatTeamId": 144,
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "DERBY Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 193,
                                            "wickets": 8,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 123,
                                            "wickets": 3,
                                            "overs": 10.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84637,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718386200000",
                                    "endDate": "1718398800000",
                                    "state": "Complete",
                                    "status": "Match tied",
                                    "team1": {
                                        "teamId": 151,
                                        "teamName": "Gloucestershire",
                                        "teamSName": "GLOUCS",
                                        "imageId": 172218
                                    },
                                    "team2": {
                                        "teamId": 148,
                                        "teamName": "Surrey",
                                        "teamSName": "SUR",
                                        "imageId": 172215
                                    },
                                    "venueInfo": {
                                        "id": 12,
                                        "ground": "Kennington Oval",
                                        "city": "London",
                                        "timezone": "+01:00",
                                        "latitude": "51.48368",
                                        "longitude": "-0.114885"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Complete"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 170,
                                            "wickets": 6,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 170,
                                            "wickets": 9,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84623,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "North Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718386200000",
                                    "endDate": "1718398800000",
                                    "state": "Complete",
                                    "status": "Warwickshire won by 4 wkts",
                                    "team1": {
                                        "teamId": 146,
                                        "teamName": "Yorkshire",
                                        "teamSName": "YORKS",
                                        "imageId": 172213
                                    },
                                    "team2": {
                                        "teamId": 140,
                                        "teamName": "Warwickshire",
                                        "teamSName": "WARKS",
                                        "imageId": 172207
                                    },
                                    "venueInfo": {
                                        "id": 20,
                                        "ground": "Edgbaston",
                                        "city": "Birmingham",
                                        "timezone": "+01:00",
                                        "latitude": "52.455774",
                                        "longitude": "-1.902624"
                                    },
                                    "currBatTeamId": 140,
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "WARKS Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 145,
                                            "wickets": 10,
                                            "overs": 19.5
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 151,
                                            "wickets": 6,
                                            "overs": 18.1
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84665,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718386200000",
                                    "endDate": "1718398800000",
                                    "state": "Complete",
                                    "status": "Somerset won by 14 runs (DLS method)",
                                    "team1": {
                                        "teamId": 119,
                                        "teamName": "Somerset",
                                        "teamSName": "SOM",
                                        "imageId": 172199
                                    },
                                    "team2": {
                                        "teamId": 150,
                                        "teamName": "Kent",
                                        "teamSName": "KENT",
                                        "imageId": 172217
                                    },
                                    "venueInfo": {
                                        "id": 223,
                                        "ground": "The Cooper Associates County Ground",
                                        "city": "Taunton",
                                        "timezone": "+01:00",
                                        "latitude": "51.018913",
                                        "longitude": "3.100894"
                                    },
                                    "currBatTeamId": 119,
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "SOM Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 55,
                                            "wickets": 6,
                                            "overs": 4.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 46,
                                            "wickets": 5,
                                            "overs": 4.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84630,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "North Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718386200000",
                                    "endDate": "1718398800000",
                                    "state": "Complete",
                                    "status": "Lancashire won by 25 runs",
                                    "team1": {
                                        "teamId": 143,
                                        "teamName": "Lancashire",
                                        "teamSName": "LANCS",
                                        "imageId": 172210
                                    },
                                    "team2": {
                                        "teamId": 145,
                                        "teamName": "Leicestershire",
                                        "teamSName": "LEIC",
                                        "imageId": 172212
                                    },
                                    "venueInfo": {
                                        "id": 222,
                                        "ground": "Grace Road",
                                        "city": "Leicester",
                                        "timezone": "+01:00",
                                        "latitude": "52.607861",
                                        "longitude": "-1.142709"
                                    },
                                    "currBatTeamId": 143,
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "LANCS Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 162,
                                            "wickets": 10,
                                            "overs": 18.5
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 137,
                                            "wickets": 9,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84616,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "North Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718382600000",
                                    "endDate": "1718395200000",
                                    "state": "Complete",
                                    "status": "Notts won by 1 run (DLS method)",
                                    "team1": {
                                        "teamId": 147,
                                        "teamName": "Worcestershire",
                                        "teamSName": "WORCS",
                                        "imageId": 172214
                                    },
                                    "team2": {
                                        "teamId": 139,
                                        "teamName": "Nottinghamshire",
                                        "teamSName": "NOTTS",
                                        "imageId": 172206
                                    },
                                    "venueInfo": {
                                        "id": 225,
                                        "ground": "New Road",
                                        "city": "Worcester",
                                        "timezone": "+01:00",
                                        "latitude": "52.189294",
                                        "longitude": "-2.2268"
                                    },
                                    "currBatTeamId": 139,
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "NOTTS Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 141,
                                            "wickets": 6,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 100,
                                            "wickets": 3,
                                            "overs": 14.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84609,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718299800000",
                                    "endDate": "1718312400000",
                                    "state": "Complete",
                                    "status": "Match abandoned due to rain",
                                    "team1": {
                                        "teamId": 149,
                                        "teamName": "Glamorgan",
                                        "teamSName": "GLAM",
                                        "imageId": 172216
                                    },
                                    "team2": {
                                        "teamId": 153,
                                        "teamName": "Hampshire",
                                        "teamSName": "HAM",
                                        "imageId": 172220
                                    },
                                    "venueInfo": {
                                        "id": 62,
                                        "ground": "Sophia Gardens",
                                        "city": "Cardiff",
                                        "timezone": "+01:00",
                                        "latitude": "51.484257",
                                        "longitude": "-3.189187"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Abandon"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84595,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718298900000",
                                    "endDate": "1718311500000",
                                    "state": "Complete",
                                    "status": "Essex won by 16 run (2nd innings reduced to 6 overs due to rain, DLS target 80)",
                                    "team1": {
                                        "teamId": 152,
                                        "teamName": "Essex",
                                        "teamSName": "ESS",
                                        "imageId": 172219
                                    },
                                    "team2": {
                                        "teamId": 74,
                                        "teamName": "Middlesex",
                                        "teamSName": "MDX",
                                        "imageId": 172170
                                    },
                                    "venueInfo": {
                                        "id": 19,
                                        "ground": "Lord's",
                                        "city": "London",
                                        "timezone": "+01:00",
                                        "latitude": "51.529488",
                                        "longitude": "-0.172926"
                                    },
                                    "currBatTeamId": 152,
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "ESS Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 129,
                                            "wickets": 4,
                                            "overs": 12.4
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 63,
                                            "wickets": 2,
                                            "overs": 5.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84602,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "North Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718213400000",
                                    "endDate": "1718226000000",
                                    "state": "Complete",
                                    "status": "Leicestershire won by 10 runs",
                                    "team1": {
                                        "teamId": 145,
                                        "teamName": "Leicestershire",
                                        "teamSName": "LEIC",
                                        "imageId": 172212
                                    },
                                    "team2": {
                                        "teamId": 141,
                                        "teamName": "Durham",
                                        "teamSName": "DUR",
                                        "imageId": 172208
                                    },
                                    "venueInfo": {
                                        "id": 60,
                                        "ground": "Riverside Ground",
                                        "city": "Chester-le-Street",
                                        "timezone": "+01:00",
                                        "latitude": "54.849531",
                                        "longitude": "-1.56103"
                                    },
                                    "currBatTeamId": 145,
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "LEIC Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 140,
                                            "wickets": 8,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 130,
                                            "wickets": 8,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84581,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718127000000",
                                    "endDate": "1718139600000",
                                    "state": "Complete",
                                    "status": "Somerset won by 9 wkts",
                                    "team1": {
                                        "teamId": 74,
                                        "teamName": "Middlesex",
                                        "teamSName": "MDX",
                                        "imageId": 172170
                                    },
                                    "team2": {
                                        "teamId": 119,
                                        "teamName": "Somerset",
                                        "teamSName": "SOM",
                                        "imageId": 172199
                                    },
                                    "venueInfo": {
                                        "id": 19,
                                        "ground": "Lord's",
                                        "city": "London",
                                        "timezone": "+01:00",
                                        "latitude": "51.529488",
                                        "longitude": "-0.172926"
                                    },
                                    "currBatTeamId": 119,
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "SOM Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 78,
                                            "wickets": 10,
                                            "overs": 16.3
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 82,
                                            "wickets": 1,
                                            "overs": 12.3
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84574,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1717943400000",
                                    "endDate": "1717956000000",
                                    "state": "Complete",
                                    "status": "Middlesex won by 4 wkts",
                                    "team1": {
                                        "teamId": 150,
                                        "teamName": "Kent",
                                        "teamSName": "KENT",
                                        "imageId": 172217
                                    },
                                    "team2": {
                                        "teamId": 74,
                                        "teamName": "Middlesex",
                                        "teamSName": "MDX",
                                        "imageId": 172170
                                    },
                                    "venueInfo": {
                                        "id": 67,
                                        "ground": "St Lawrence Ground",
                                        "city": "Canterbury",
                                        "timezone": "+01:00",
                                        "latitude": "51.267447",
                                        "longitude": "1.091621"
                                    },
                                    "currBatTeamId": 74,
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "MDX Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 173,
                                            "wickets": 8,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 178,
                                            "wickets": 6,
                                            "overs": 19.2
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84560,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "North Group",
                                    "matchFormat": "T20",
                                    "startDate": "1717941600000",
                                    "endDate": "1717954200000",
                                    "state": "Complete",
                                    "status": "Yorkshire won by 9 wkts",
                                    "team1": {
                                        "teamId": 144,
                                        "teamName": "Derbyshire",
                                        "teamSName": "DERBY",
                                        "imageId": 172211
                                    },
                                    "team2": {
                                        "teamId": 146,
                                        "teamName": "Yorkshire",
                                        "teamSName": "YORKS",
                                        "imageId": 172213
                                    },
                                    "venueInfo": {
                                        "id": 66,
                                        "ground": "Headingley",
                                        "city": "Leeds",
                                        "timezone": "+01:00",
                                        "latitude": "53.817622",
                                        "longitude": "-1.58211"
                                    },
                                    "currBatTeamId": 146,
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "YORKS Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 179,
                                            "wickets": 6,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 182,
                                            "wickets": 1,
                                            "overs": 18.1
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84546,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "North Group",
                                    "matchFormat": "T20",
                                    "startDate": "1717939800000",
                                    "endDate": "1717952400000",
                                    "state": "Complete",
                                    "status": "Leicestershire won by 4 runs",
                                    "team1": {
                                        "teamId": 145,
                                        "teamName": "Leicestershire",
                                        "teamSName": "LEIC",
                                        "imageId": 172212
                                    },
                                    "team2": {
                                        "teamId": 147,
                                        "teamName": "Worcestershire",
                                        "teamSName": "WORCS",
                                        "imageId": 172214
                                    },
                                    "venueInfo": {
                                        "id": 222,
                                        "ground": "Grace Road",
                                        "city": "Leicester",
                                        "timezone": "+01:00",
                                        "latitude": "52.607861",
                                        "longitude": "-1.142709"
                                    },
                                    "currBatTeamId": 145,
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "LEIC Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 176,
                                            "wickets": 8,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 172,
                                            "wickets": 6,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84567,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1717939800000",
                                    "endDate": "1717952400000",
                                    "state": "Complete",
                                    "status": "Sussex won by 48 runs",
                                    "team1": {
                                        "teamId": 41,
                                        "teamName": "Sussex",
                                        "teamSName": "SUS",
                                        "imageId": 172148
                                    },
                                    "team2": {
                                        "teamId": 151,
                                        "teamName": "Gloucestershire",
                                        "teamSName": "GLOUCS",
                                        "imageId": 172218
                                    },
                                    "venueInfo": {
                                        "id": 63,
                                        "ground": "County Ground",
                                        "city": "Bristol",
                                        "timezone": "+01:00",
                                        "latitude": "51.477246",
                                        "longitude": "-2.584212"
                                    },
                                    "currBatTeamId": 41,
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "SUS Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 208,
                                            "wickets": 6,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 160,
                                            "wickets": 8,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84553,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1717939800000",
                                    "endDate": "1717952400000",
                                    "state": "Complete",
                                    "status": "Somerset won by 63 runs",
                                    "team1": {
                                        "teamId": 119,
                                        "teamName": "Somerset",
                                        "teamSName": "SOM",
                                        "imageId": 172199
                                    },
                                    "team2": {
                                        "teamId": 153,
                                        "teamName": "Hampshire",
                                        "teamSName": "HAM",
                                        "imageId": 172220
                                    },
                                    "venueInfo": {
                                        "id": 223,
                                        "ground": "The Cooper Associates County Ground",
                                        "city": "Taunton",
                                        "timezone": "+01:00",
                                        "latitude": "51.018913",
                                        "longitude": "3.100894"
                                    },
                                    "currBatTeamId": 119,
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "SOM Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 241,
                                            "wickets": 5,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 178,
                                            "wickets": 10,
                                            "overs": 19.3
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84539,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "North Group",
                                    "matchFormat": "T20",
                                    "startDate": "1717939800000",
                                    "endDate": "1717952400000",
                                    "state": "Complete",
                                    "status": "Lancashire won by 6 wkts",
                                    "team1": {
                                        "teamId": 139,
                                        "teamName": "Nottinghamshire",
                                        "teamSName": "NOTTS",
                                        "imageId": 172206
                                    },
                                    "team2": {
                                        "teamId": 143,
                                        "teamName": "Lancashire",
                                        "teamSName": "LANCS",
                                        "imageId": 172210
                                    },
                                    "venueInfo": {
                                        "id": 18,
                                        "ground": "Trent Bridge",
                                        "city": "Nottingham",
                                        "timezone": "+01:00",
                                        "latitude": "52.936884",
                                        "longitude": "-1.132230"
                                    },
                                    "currBatTeamId": 143,
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "LANCS Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 153,
                                            "wickets": 8,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 155,
                                            "wickets": 4,
                                            "overs": 18.3
                                        }
                                    }
                                }
                            }
                        ]
                    }
                }
            ]
        },
        {
            "matchType": "Women",
            "seriesMatches": [
                {
                    "seriesAdWrapper": {
                        "seriesId": 8296,
                        "seriesName": "Czech Republic Women tour of Austria, 2024",
                        "matches": [
                            {
                                "matchInfo": {
                                    "matchId": 96658,
                                    "seriesId": 8296,
                                    "seriesName": "Czech Republic Women tour of Austria, 2024",
                                    "matchDesc": "3rd T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1717921800000",
                                    "endDate": "1717934400000",
                                    "state": "Complete",
                                    "status": "Austria Women won by 106 runs",
                                    "team1": {
                                        "teamId": 775,
                                        "teamName": "Austria Women",
                                        "teamSName": "AUTW",
                                        "imageId": 274436
                                    },
                                    "team2": {
                                        "teamId": 1987,
                                        "teamName": "Czech Republic Women",
                                        "teamSName": "CZEW",
                                        "imageId": 501075
                                    },
                                    "venueInfo": {
                                        "id": 714,
                                        "ground": "Seebarn Cricket Ground",
                                        "city": "Seebarn",
                                        "timezone": "+02:00",
                                        "latitude": "48.380428",
                                        "longitude": "16.388220"
                                    },
                                    "currBatTeamId": 775,
                                    "seriesStartDt": "1717804800000",
                                    "seriesEndDt": "1718064000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "AUTW Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 161,
                                            "wickets": 8,
                                            "overs": 20.0
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 55,
                                            "wickets": 7,
                                            "overs": 20.0
                                        }
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    "seriesAdWrapper": {
                        "seriesId": 8323,
                        "seriesName": "Women Central Europe Cup, 2024",
                        "matches": [
                            {
                                "matchInfo": {
                                    "matchId": 96944,
                                    "seriesId": 8323,
                                    "seriesName": "Women Central Europe Cup, 2024",
                                    "matchDesc": "4th Match",
                                    "matchFormat": "T20",
                                    "startDate": "1718452800000",
                                    "endDate": "1718465400000",
                                    "state": "Complete",
                                    "status": "Croatia Women won by 9 wkts",
                                    "team1": {
                                        "teamId": 1987,
                                        "teamName": "Czech Republic Women",
                                        "teamSName": "CZEW",
                                        "imageId": 501075
                                    },
                                    "team2": {
                                        "teamId": 1994,
                                        "teamName": "Croatia Women",
                                        "teamSName": "CRTW",
                                        "imageId": 501076
                                    },
                                    "venueInfo": {
                                        "id": 941,
                                        "ground": "Scott Page Field, Vinor",
                                        "city": "Prague",
                                        "timezone": "+02:00",
                                        "latitude": "50.0755",
                                        "longitude": "14.4378"
                                    },
                                    "currBatTeamId": 1994,
                                    "seriesStartDt": "1718323200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "CRTW Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 110,
                                            "wickets": 4,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 113,
                                            "wickets": 1,
                                            "overs": 12.4
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96935,
                                    "seriesId": 8323,
                                    "seriesName": "Women Central Europe Cup, 2024",
                                    "matchDesc": "3rd Match",
                                    "matchFormat": "T20",
                                    "startDate": "1718438400000",
                                    "endDate": "1718451000000",
                                    "state": "Complete",
                                    "status": "Croatia Women won by 29 runs",
                                    "team1": {
                                        "teamId": 1994,
                                        "teamName": "Croatia Women",
                                        "teamSName": "CRTW",
                                        "imageId": 501076
                                    },
                                    "team2": {
                                        "teamId": 1507,
                                        "teamName": "Gibraltar Women",
                                        "teamSName": "GIBW",
                                        "imageId": 297980
                                    },
                                    "venueInfo": {
                                        "id": 941,
                                        "ground": "Scott Page Field, Vinor",
                                        "city": "Prague",
                                        "timezone": "+02:00",
                                        "latitude": "50.0755",
                                        "longitude": "14.4378"
                                    },
                                    "currBatTeamId": 1994,
                                    "seriesStartDt": "1718323200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "CRTW Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 127,
                                            "wickets": 6,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 98,
                                            "wickets": 7,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96928,
                                    "seriesId": 8323,
                                    "seriesName": "Women Central Europe Cup, 2024",
                                    "matchDesc": "2nd Match",
                                    "matchFormat": "T20",
                                    "startDate": "1718366400000",
                                    "endDate": "1718379000000",
                                    "state": "Complete",
                                    "status": "Croatia Women won by 71 runs",
                                    "team1": {
                                        "teamId": 1994,
                                        "teamName": "Croatia Women",
                                        "teamSName": "CRTW",
                                        "imageId": 501076
                                    },
                                    "team2": {
                                        "teamId": 1987,
                                        "teamName": "Czech Republic Women",
                                        "teamSName": "CZEW",
                                        "imageId": 501075
                                    },
                                    "venueInfo": {
                                        "id": 941,
                                        "ground": "Scott Page Field, Vinor",
                                        "city": "Prague",
                                        "timezone": "+02:00",
                                        "latitude": "50.0755",
                                        "longitude": "14.4378"
                                    },
                                    "currBatTeamId": 1994,
                                    "seriesStartDt": "1718323200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "CRTW Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 191,
                                            "wickets": 1,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 120,
                                            "wickets": 6,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96926,
                                    "seriesId": 8323,
                                    "seriesName": "Women Central Europe Cup, 2024",
                                    "matchDesc": "1st Match",
                                    "matchFormat": "T20",
                                    "startDate": "1718352000000",
                                    "endDate": "1718364600000",
                                    "state": "Complete",
                                    "status": "Gibraltar Women won by 54 runs",
                                    "team1": {
                                        "teamId": 1507,
                                        "teamName": "Gibraltar Women",
                                        "teamSName": "GIBW",
                                        "imageId": 297980
                                    },
                                    "team2": {
                                        "teamId": 1987,
                                        "teamName": "Czech Republic Women",
                                        "teamSName": "CZEW",
                                        "imageId": 501075
                                    },
                                    "venueInfo": {
                                        "id": 941,
                                        "ground": "Scott Page Field, Vinor",
                                        "city": "Prague",
                                        "timezone": "+02:00",
                                        "latitude": "50.0755",
                                        "longitude": "14.4378"
                                    },
                                    "currBatTeamId": 1507,
                                    "seriesStartDt": "1718323200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "GIBW Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 141,
                                            "wickets": 4,
                                            "overs": 19.6
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 87,
                                            "wickets": 7,
                                            "overs": 19.6
                                        }
                                    }
                                }
                            }
                        ]
                    }
                },
                {
                    "seriesAdWrapper": {
                        "seriesId": 8249,
                        "seriesName": "West Indies Women tour of Sri Lanka, 2024",
                        "matches": [
                            {
                                "matchInfo": {
                                    "matchId": 96253,
                                    "seriesId": 8249,
                                    "seriesName": "West Indies Women tour of Sri Lanka, 2024",
                                    "matchDesc": "1st ODI (ICC Championship Match)",
                                    "matchFormat": "ODI",
                                    "startDate": "1718425800000",
                                    "endDate": "1718454600000",
                                    "state": "Complete",
                                    "status": "Sri Lanka Women won by 6 wkts",
                                    "team1": {
                                        "teamId": 257,
                                        "teamName": "West Indies Women",
                                        "teamSName": "WIW",
                                        "imageId": 172310
                                    },
                                    "team2": {
                                        "teamId": 258,
                                        "teamName": "Sri Lanka Women",
                                        "teamSName": "SLW",
                                        "imageId": 172311
                                    },
                                    "venueInfo": {
                                        "id": 255,
                                        "ground": "Mahinda Rajapaksa International Stadium",
                                        "city": "Hambantota",
                                        "timezone": "+05:30",
                                        "latitude": "6.353636",
                                        "longitude": "81.026801"
                                    },
                                    "currBatTeamId": 258,
                                    "seriesStartDt": "1718409600000",
                                    "seriesEndDt": "1719705600000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "SLW Won"
                                },
                                "matchScore": {
                                    "team1Score": {
                                        "inngs1": {
                                            "inningsId": 1,
                                            "runs": 195,
                                            "wickets": 10,
                                            "overs": 47.1
                                        }
                                    },
                                    "team2Score": {
                                        "inngs1": {
                                            "inningsId": 2,
                                            "runs": 198,
                                            "wickets": 4,
                                            "overs": 34.1
                                        }
                                    }
                                }
                            }
                        ]
                    }
                }
            ]
        }
    ],
    "filters": {
        "matchType": [
            "International",
            "League",
            "Domestic",
            "Women"
        ]
    },
    "appIndex": {
        "seoTitle": "Live Cricket Score - Scorecard and Match Results",
        "webURL": "www.cricbuzz.com/live-cricket-scores/"
    },
    "responseLastUpdated": "1718499178"
}
